var app = angular.module("leonardo");

var DeleteTasksList = function($scope, $controller, FilterService, TaskService) {

  $scope.getEntitiesPromise = function(options) {
    options['account'] = FilterService.getFilter('account_reports');
    options['group'] = FilterService.getFilter('group_reports');
    options['portfolio'] = FilterService.getFilter('portfolio_reports');
    options['property'] = FilterService.getFilter('property_reports');
    options['from_due_date'] = FilterService.getFilter('date_from');
    options['to_due_date'] = FilterService.getFilter('date_to');
    options['only_status_pending'] = FilterService.getFilter('only_status_pending');
    options['include_workflow_and_unit_workflow_tasks'] = FilterService.getFilter('include_workflow_and_unit_workflow_tasks');
    options['include_document_tasks'] = FilterService.getFilter('include_document_tasks');
    options['include_personal_tasks'] = FilterService.getFilter('include_personal_tasks');
    return TaskService.getPastDue(options);
  };

  $controller('TableFilterController', { $scope: $scope });


  $scope.$on('delete-past-due-tasks:updated', function (){
    $scope.loadPage(1);
  });

};

app.controller('DeleteTasksList', ['$scope', '$controller', 'FilterService', 'TaskService', DeleteTasksList]);
